<div [style.background-color]="brandingDetails?.branding?.BackgroundColors?.Headers" class="Header col-12 nopad">
  <div class="d-flex justify-content-between headerSpace">
    <div class="headerTextContainer">
      <div class="GroupHeader">
        <h2 class="styledName">{{'P-CIS' | translate}}</h2>
        <p class="styledName">{{getAgencyName()}}</p>
      </div>
    </div>
    <div class="UserNameSearchBoxContainer d-flex rightSpace">
      <span class="search">
        <div><input placeholder="{{'Search' | translate }}" (keyup.enter)="search()" [(ngModel)]="searchInput" [attr.aria-label]="'Search' | translate"
            class="searchInput" type="text" maxlength="35" /></div>
        <div><i class="fa fa-search icon-hover" (click)="search()"></i></div>
      </span>
      <span class="search">
        <select [(ngModel)]="language" (change)="changeLanguage(language.attribute)" [attr.aria-label]="'Select language' | translate">
          <option *ngFor="let language of languages" [value]="language.attribute">
            {{ language.language | translate }}&nbsp;{{language.workForce !== ""? '(' +language.workForce + ')'  : '' | translate}}
          </option>
        </select>
      </span>
      <app-notification-icon *ngIf="notificationPermission"></app-notification-icon>
      <div class="styledToggleProfile" (click)="toggleProfile()" #toggleProfileClick>
        <div class="d-flex styledUProfile">
          <div>
            <img [src]="imageURL | safeUrl" class="styledUser" *ngIf="imageURL" alt="User Image">
            <span class="styledUser" *ngIf="!imageURL"></span>
          </div>
          <div class="userGroup">
            <span class="userName">{{getUserName()}}</span>
            <span *ngIf="!userFlag" class="designation text-light">{{getUserTitle()}}</span>
            <span *ngIf="userFlag" class="designation text-light">{{'Super Admin' | translate}}</span>
          </div>

          <span>
            <i [ngClass]="{'fa fa-caret-down': show}"></i>
            <i [ngClass]="{'fa fa-caret-up':!show}"></i>
          </span>
        </div>
        <div *ngIf="!show" class="profileDropdown" #logoutoption [style.background-color]="dropdownBackgroundcolor">
          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link" href="javascript:void(0)" [routerLink]="['/profile']">{{'View Profile' |
                translate}}</a>
            </li>
            <li class="nav-item border-top">
              <a class="nav-link" href="javascript:void(0)" (click)="goToLink('https://support.p-cis.com')">
                {{ language === 'en-magellan' ? getSupportLabel() : ('Support' | translate) }}
              </a>
            </li>
            <li class="nav-item border-top">
              <a class="nav-link" href="javascript:void(0)" (click)="logoutEvent()">{{'Logout' |
                translate}}</a>
            </li>
          </ul>
        </div>
      </div>
      <app-logout-confirmation-dialog [Message]="conformMessage" (modalEvent)="conformLogout($event)">
      </app-logout-confirmation-dialog>
    </div>
  </div>
</div>
